// ── useBootSound — one boot chime per app boot ───────────────────
// Extracted verbatim from App.tsx (#419) so the emitter's channel-volume
// contract can be asserted without rendering the routed application.

import { useEffect, useRef } from 'react';
import { getChannelVolume } from '../lib/alerts/alertPreferences';
import { playBootTone } from '../lib/audio/defenseAudio';
import { readSoundSettings } from '../lib/audio/soundSettings';

export function useBootSound(): void {
  const bootPlayed = useRef(false);
  useEffect(() => {
    if (!bootPlayed.current) {
      bootPlayed.current = true;
      const snd = readSoundSettings();
      if (snd.bootSoundEnabled) playBootTone(getChannelVolume('boot'));
    }
  }, []);
}
